import {Controller} from "./helpers/controller";

export class ReadMoreControl extends Controller {

    constructor(element: HTMLElement) {
        super(element);

        $(element).on('click', (e)=>{
            const readMoreText = 'Read more';
            const readLessText = 'Read less';

            let switchElement = $(e.currentTarget);
            let targetCover = switchElement.prev();

            if (switchElement.text().trim() == readMoreText) {
                switchElement.text(readLessText);
            } else {
                switchElement.text(readMoreText);
            }

            targetCover.toggleClass("readCover");
        });
    }

}